import { SORT_TYPES } from '@web-platform/shared-universal-constants/src/sort';

import type { SortTypes } from '@web-platform/shared-universal-constants/src/sort';

const { BEST, CHEAPEST, DEPARTURE_INBOUND_ASC, DEPARTURE_OUTBOUND_ASC, FASTEST } = SORT_TYPES;

export const parseSortOption = (str?: string, defaultOption: SortTypes = BEST): SortTypes => {
  const lowerString = str?.toLowerCase();

  switch (lowerString) {
    case 'cheapest':
      return CHEAPEST;

    case 'fastest':
      return FASTEST;

    case 'best':
      return BEST;

    case 'departure_outbound_asc':
      return DEPARTURE_OUTBOUND_ASC;

    case 'departure_inbound_asc':
      return DEPARTURE_INBOUND_ASC;

    default:
      return defaultOption;
  }
};
